import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuRichTextProps } from '../WbuRichText.props';

export const props = withCompInfo<IWbuRichTextProps, any>()(
  ['compData'],
  ({ compData }) => {
    return compData;
  },
);

export default createComponentMapperModel({
  props,
});
